import candyTheme from '../src/candy/';

FusionCharts.addDep(candyTheme);
